import React, { useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { WelcomePage } from './pages/WelcomePage';
import { OnboardingFlow } from './components/onboarding/OnboardingFlow';
import { ClientApp } from './components/client';
import { TrainerApp } from './components/trainer';
import { ErrorBoundary } from './components/ErrorBoundary';
import { PasswordProtection } from './components/PasswordProtection';
import { useVacationMode } from './features/vacation';
import { VacationMode } from './components/vacation/VacationMode';

export function App() {
  const [hasEnteredPassword, setHasEnteredPassword] = useState(false);
  const { isVacationMode } = useVacationMode();

  if (!hasEnteredPassword) {
    return <PasswordProtection onSuccess={() => setHasEnteredPassword(true)} />;
  }

  return (
    <ErrorBoundary>
      {isVacationMode && <VacationMode />}
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/welcome" element={<WelcomePage />} />
        <Route path="/onboarding" element={<OnboardingFlow />} />
        <Route path="/*" element={<ClientApp />} />
        <Route path="/trainer/*" element={<TrainerApp />} />
      </Routes>
    </ErrorBoundary>
  );
}